module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "aria-labelledby": "headereditor01",
      "epub:type": "frontmatter",
      "id": "editor"
    }
  }, [_c('header', {
    attrs: {
      "id": "headereditor01"
    }
  }, [_c('h1', {
    staticClass: "ctfm"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": " Page vi. ",
      "epub:type": "pagebreak",
      "id": "pvi",
      "role": "doc-pagebreak"
    }
  }), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": " Page vii. ",
      "epub:type": "pagebreak",
      "id": "pvii",
      "role": "doc-pagebreak"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chifoucaultcritique0006#reditor"
    }
  }, [_vm._v("Editors’ Note")])])]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "pvii"
    }
  }), _vm._v("This volume presents two lectures by Michel Foucault: (1) a lecture delivered in French at the Sorbonne to the Société française de Philosophie on May 27, 1978, and published in 1990 under the title “Qu’est-ce que la critique? (Critique et "), _c('i', [_vm._v("Aufklärung")]), _vm._v(")” and (2) a lecture delivered in English on April 12, 1983, at the University of California, Berkeley, titled “The Culture of the Self.”")]), _vm._v(" "), _c('p', [_vm._v("In the days following this second lecture, Foucault took part in three discussions at Berkeley organized respectively by the departments of philosophy, history, and French. Transcriptions of these discussions—the first two in English and the third in French—can be found after the lecture in this volume. Five years separate these two lectures, a period during which Foucault’s thought underwent significant evolution. Nonetheless, we thought it would be interesting to publish these two texts together. A few months prior to his lecture in April 1983, Foucault began his course at the Collège of France on "), _c('i', [_vm._v("The Government of Self and Others")]), _vm._v(", with a long discussion on the Aufklärung, echoing the theme of his lecture to the Société française de Philosophie in May 1978.")]), _vm._v(" "), _c('p', [_vm._v("The texts were prepared as follows:")]), _vm._v(" "), _c('p', [_vm._v("For the 1978 lecture we consulted the transcript published in the "), _c('i', [_vm._v("Bulletin de la Société française de Philosophie")]), _vm._v(" 84, no. 2 "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": " Page viii. ",
      "epub:type": "pagebreak",
      "id": "pviii",
      "role": "doc-pagebreak"
    }
  }), _vm._v("(April–June 1990): 35–63. A number of changes were made to this transcript after viewing the manuscript held by the Bibliothèque nationale in France. These changes include (1) passages omitted by Foucault in his oral presentation and (2) variants from a first version of the transcript sent to Foucault for proofreading (a version that does not include his hand-written corrections).")]), _vm._v(" "), _c('p', [_vm._v("For the lecture delivered at Berkeley on April 12, 1983, and for the three discussions that followed it, we consulted the recordings held by the University of California, Berkeley, and the Institut Mémoires de l’Édition Contemporaine (IMEC). Davey K. Tomlinson assisted with the English transcriptions. We were also able to consult the manuscript of the lecture at the Bibliothèque nationale in France.")]), _vm._v(" "), _c('p', [_vm._v("The texts have been rendered as literally as possible. We have omitted some repetitions and hesitations when Foucault was searching for words, and we have corrected some incorrect sentences in the debates in English when it was essential. We have also taken the liberty of summarizing the questions in the debates and omitting certain exchanges that were off track. Editorial interventions are indicated with square brackets throughout the text. When the text of the spoken lectures differs significantly from Foucault’s written manuscripts, the alternate text is provided in a footnote.")]), _vm._v(" "), _c('p', [_vm._v("We would particularly like to thank the Bibliothèque nationale in France for their invaluable help and allowing us to consult documents in the Foucault collection that are not yet available to the public. We also thank the Société française de Philosophie for kindly authorizing the republication of the discussion which followed Michel Foucault’s lecture on May 27, 1978.")]), _vm._v(" "), _c('p', {
    staticClass: "patr"
  }, [_vm._v("Henri-Paul Fruchaud and Daniele Lorenzini")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-90f3c870","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-foucault-critique-0007.vue
// module id = 72
// module chunks = 0